module.exports = __webpack_public_path__ + "img/image10.977f98bb.png";